<template>
  <vab-icon
    v-if="theme.showInformation"
    icon="information-line"
    @click="handleClick"
  />
  <information ref='information' />
</template>

<script>
  import { ref, computed, getCurrentInstance } from 'vue'
  import { useStore } from 'vuex'
  import { useRoute, useRouter } from 'vue-router'
  import Information from '@/views/components/information.vue'

  export default {
    name: 'VabInformation',
    components: { Information },
    setup() {
      const store = useStore()
      const route = useRoute()
      const router = useRouter()
      const { proxy } = getCurrentInstance()
      const extra = computed(() => store.getters['settings/extra'])
      const theme = computed(() => store.getters['settings/theme'])
      const visitedRoutes = computed(() => store.getters['tabs/visitedRoutes'])
      const information = ref(null)

      const handleClick = () => {
        information.value.showInformation()
      }

      return {
        theme,
        information,
        handleClick,
      }
    },
  }
</script>
